import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import { selectSelectedGroupIds, selectOptInGroups } from 'state/selectors/subscriptionSelectors';
import GroupSubscriptionInput from './GroupSubscriptionInput';
import './SubscriptionContent.scss';


const GroupSubscriptionContent = ({
  selectedGroupIds, setGroupData, optInGroups: { groups, name }, isInLoggedInEditProfileMode
}) => (
  <div>
    {
      isInLoggedInEditProfileMode ? 
      <h2 className="graybg h2-logged-in">{name}</h2>:
      <h3 className="graybg">{name}</h3>
    }
    <ul className="tree root-level">
      {_.map(groups, (groupsChildNode, index) =>
        <GroupSubscriptionInput
          key={index}
          groups={groupsChildNode}
          isRootElement
          selectedGroupIds={selectedGroupIds}
          setGroupData={setGroupData}
        />
      )}
    </ul>
  </div>
);

GroupSubscriptionContent.propTypes = {
  selectedGroupIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  optInGroups: PropTypes.shape().isRequired,
  setGroupData: PropTypes.func.isRequired,
};
const mapStateToProps = state => ({
  optInGroups: selectOptInGroups(state),
  selectedGroupIds: selectSelectedGroupIds(state),
});

export default connect(mapStateToProps)(GroupSubscriptionContent);
